import $ from 'jquery'

// Role edit: the modules, estates and service group categories an acquisitor
// or analyst is limited to. Each list counts its ticked boxes, and its box for
// all of them shows whether all, some or none are ticked.
const syncScopeList = (list) => {
  const items = $(list).find('.role-scope-items input[type=checkbox]')
  const checked = items.filter(':checked').length
  $(list).find('.checkbox_select_all')
    .prop('checked', checked > 0 && checked === items.length)
    .prop('indeterminate', checked > 0 && checked < items.length)
  const count = $(list).find('.role-scope-count')
  count.text(count.data('template').replace('%{checked}', checked).replace('%{total}', items.length))
}

$(document).on('turbo:load', () => {
  $('.role-scope-list').each((_, list) => syncScopeList(list))
})

$(document).on('change', '.role-scope-list .checkbox_select_all', function() {
  const list = $(this).closest('.role-scope-list')
  list.find('.role-scope-items input[type=checkbox]').prop('checked', $(this).prop('checked'))
  syncScopeList(list)
})

$(document).on('change', '.role-scope-items input[type=checkbox]', function() {
  syncScopeList($(this).closest('.role-scope-list'))
})

// Only an acquisitor or analyst is limited, the other roles see everything
$(document).on('change', 'input[name=new_role]', function() {
  $('#role_scope').prop('hidden', !$(this).data('scoped'))
})
